import 'flickity/dist/flickity.pkgd';

import ScrollOut from 'scroll-out';

export default {
  init() {
    // HAMBURGER
    $('.hamburger').click(function() {
      $(this).toggleClass('active');
      $('body').toggleClass('hamburger-active');
    });

    // SUBMENUS
    $('.sub-menu').wrapInner('<div class="menu-wrapper w-full md:w-2/3 pl-8"></div>');
    $('.sub-menu').wrapInner('<div class="submenu-wrapper max-w-screen-xl mx-auto flex justify-between flex-wrap items-center py-4 px-4 sm:px-6 lg:py-5 lg:px-8"><div class="container ease-in-out duration-500 transition-all flex flex-wrap"></div></div>');
    $('.menu-description').each(function(){
        //$(this).appendTo('.sub-menu .submenu-wrapper .container');
        var $submenu = $(this).closest('li').find('.sub-menu .container');
        $submenu.prepend( $(this) );
        $(this).removeClass('hidden');
    });
    $('.menu-image').each(function(){
        //$(this).appendTo('.sub-menu .submenu-wrapper .container');
        var $submenu = $(this).closest('li').find('.sub-menu .container');
        $submenu.prepend( $(this) );
        $(this).removeClass('hidden');
    });

    // HAMBURGER
    $('.mobile-nav .menu-mobiel-container ul li.menu-item-has-children').click(function() {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $('.mobile-nav .menu-mobiel-container ul li.menu-item-has-children').removeClass('active');
        $(this).addClass('active');
      }
    });

    // VIDEO
    $('video').click(function(){
      this.paused ? this.play() : this.pause();
    });

    $('video').click(function() {
      $('body').toggleClass( 'playing' );
    });

    // ACCORDEON
    $(function() {
      $('.accordeon > .accordeon-item.is-active').children('.accordeon-panel').slideDown();
      $('.accordeon > .accordeon-item').click(function() {
        $(this).siblings('.accordeon-item').removeClass('is-active').children('.accordeon-panel').slideUp();
        $(this).toggleClass('is-active').children('.accordeon-panel').slideToggle('ease-out');
      });
    });

    // BASICSCROLL
    ScrollOut({
      // once: true,
      cssProps: {
        visibleY: true,
        viewportY: true,
      },
    })
  },
  finalize() {
    if($('.slider').length) {

      // var cellSelector = $('.slider__cell');
      // var $slides = $(cellSelector).clone();
      // $slides.addClass('show-if-flickity-enabled');
      // $(cellSelector)
      //   .last()
      //   .after($slides);

      var $carousel = $('.slider').flickity({
        cellAlign: 'center',
        contain: true,
        draggable: true,
        wrapAround: true,
        prevNextButtons: true,
        autoPlay: 6000,
        pageDots: false,
        pauseAutoPlayOnHover: false,
      });

      // Flickity instance
      var flkty = $carousel.data('flickity');
      // elements
      var $cellButtonGroup = $('.button-group--cells');
      var $cellButtons1 = $cellButtonGroup.find('.dot');

      // update selected cellButtons
      $carousel.on( 'select.flickity', function() {
        $cellButtons1.filter('.is-selected')
        .removeClass('is-selected');
        $cellButtons1.eq( flkty.selectedIndex )
        .addClass('is-selected');
      });

      // select cell on button click
      $cellButtonGroup.on( 'click', '.dot', function() {
        var index = $(this).index();
        $carousel.flickity( 'select', index );
      });

      setTimeout(function() {
        $('.slider').flickity('resize');
      }, 250);

      $('.slider').on( 'select.flickity', function() { $('.slider').flickity('playPlayer') });
    }

    // TABNAV
    (function($) {
      $.fn.tabnav = function tabnav(userConfig) {
        var config = $.extend({
          activeTabClass: 'active',
          activePanelClass: 'active',
        }, userConfig);

        var $wrapper = $(this);
        var $tabs = $wrapper.find('.js-tabnav-tab');
        var $panels = $wrapper.find('.js-tabnav-panel');
        var $panelsWrapper = $wrapper.find('.js-tabnav-panels');
        var $activeTab;
        var $activePanel;
        var activeTab = 0;

        console.log($activeTab);
        console.log(activeTab);

        $panels
        .attr('role', 'tabpanel')
        .attr('aria-hidden', 'true');

        $tabs
        .attr('role', 'tab')
        .attr('aria-selected', 'false')
        .attr('aria-setsize', $tabs.length)
        .attr('tabindex', 0)
        .each(function(i, e) {
          var $elem = $(e);
          if ($elem.hasClass(config.activeTabClass)) {
            setActiveTab(i);
          }
          $elem.attr('aria-posinset', i + 1);
        })
        .click(setTabs)
        .keypress(setTabs);

        function setActiveTab(tabPos) {
          $activeTab = $($tabs.get(tabPos))
          .addClass(config.activeTabClass)
          .attr('aria-selected', 'true');

          $activePanel = $($panels.get(tabPos))
          .addClass(config.activePanelClass)
          .attr('aria-hidden', 'false');

          $panelsWrapper.css('height', $activePanel.height() + 'px');
        }

        function setTabs(e) {
          if (e.type === 'keypress' && e.keyCode !== 13) {
            return;
          }

          var $elem = $(e.currentTarget);

          var tabPos = Number($elem.attr('aria-posinset')) - 1;
          $tabs
          .removeClass(config.activeTabClass)
          .attr('aria-selected', 'false');
          $panels
          .removeClass(config.activePanelClass)
          .attr('aria-hidden', 'true');

          setActiveTab(tabPos);
        }

        $(window).resize(function onWindowResize() {
          $panelsWrapper.css('height', $activePanel.height() + 'px');
        });

        $(window).load(function() {
          $panelsWrapper.css('height', $activePanel.height() + 'px');
        });
      }
    }(jQuery));

    var tabnav = $('.tabnav');
    if (tabnav.length != 0) {
      $(tabnav).each(function(){
        $(this).tabnav();
        console.log(tabnav)
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js